import { pointInPolygon } from '../../components/new-project-cad/cadUtils.ts';
import type { MeasurementPlane, PlaneVec2 } from '../../store/reducers/measurementPlanes.reducer.ts';

const MAX_POINTS = 20000; // guard against a huge footprint with tiny spacing

/**
 * Regular grid of (u,v) coordinates inside the plane polygon. Horizontal planes use
 * world XY; oriented planes use frame (u,v). The runner then DRAPES each coordinate
 * onto the real model surface (raycast) so points sit on the layer, not a flat plane.
 */
export function samplePlaneGrid(plane: MeasurementPlane, spacing: number): PlaneVec2[] {
  const poly = plane.polygon;
  if (poly.length < 3) return [];

  let minA = Infinity;
  let minB = Infinity;
  let maxA = -Infinity;
  let maxB = -Infinity;
  for (const [a, b] of poly) {
    if (a < minA) minA = a;
    if (a > maxA) maxA = a;
    if (b < minB) minB = b;
    if (b > maxB) maxB = b;
  }

  const holes = (plane.exclusions ?? []).filter((h) => h.length >= 3);
  const step = spacing > 0 ? spacing : 0.5;
  const out: PlaneVec2[] = [];
  for (let a = minA; a <= maxA; a += step) {
    for (let b = minB; b <= maxB; b += step) {
      if (!pointInPolygon(a, b, poly)) continue;
      // Skip points that fall inside a cut-out region (e.g. the centre of a roundabout).
      if (holes.some((h) => pointInPolygon(a, b, h))) continue;
      out.push([a, b]);
      if (out.length >= MAX_POINTS) return out;
    }
  }
  return out;
}
